module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shipping-methods"
  }, [_c('h4', [_vm._v("Shipping Method")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n    Business Days are the carrier's estimated time in transit to deliver your order after it ships."), _c('br'), _vm._v("\n    Select a USPS Shipping Method for PO Box deliveries.\n  ")]), _vm._v("\n  " + _vm._s(_vm.address) + "\n  "), (!!_vm.address && _vm.shippingMethods > 0) ? _c('v-form', {
    ref: "shippingMethodForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    }
  }, [_vm._l((_vm.shippingMethods), function(method) {
    return [(_vm.showTitle(method.service)) ? _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h4', {
      staticClass: "right"
    }, [_vm._v("Shipping & Processing")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(method.service))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-radio', {
      attrs: {
        "label": method.name,
        "value": method.code
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "right-align": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(method.rate)) + "\n          ")])], 1)]
  })], 2)], 1) : _c('div', {
    staticClass: "loading center-align pt-5 pb-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "indeterminate": ""
    }
  }), _c('br'), _vm._v("\n    Loading Shipping Methods...\n  ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38375fe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/shipping-methods.vue
// module id = 724
// module chunks = 1